import { WASTE_STREAMS, parseCSVLine } from "../constants/wasteData";

export const ACCOUNT_CSV_HEADERS=[
  "location_name","stream","container_type","container_quantity","container_size","size_unit",
  "weekly_pickup_frequency","hauler_name","account_number","has_volume","volume_unit","has_weight","weight_unit","notes",
];

export function buildAccountCsvTemplate(){
  const header=ACCOUNT_CSV_HEADERS.join(",");
  const example=[
    "Main Lodge","MSW","Dumpster","2","6","yard","3","Waste Connections","ACCT-12345","yes","cubic_yards","yes","tons","Behind kitchen loading dock",
  ].join(",");
  return `${header}\n${example}\n`;
}

function parseYesNo(s,field,rowNum){
  const v=(s||"").trim().toLowerCase();
  if(v==="yes") return {value:true};
  if(v==="no") return {value:false};
  return {error:`Row ${rowNum}: "${field}" must be "yes" or "no" (got "${s}").`};
}
function parseOptionalNumber(s,field,rowNum){
  const v=(s||"").trim();
  if(v==="") return {value:null};
  const n=Number(v);
  if(Number.isNaN(n)||n<0) return {error:`Row ${rowNum}: "${field}" value "${s}" is not a valid number.`};
  return {value:n};
}

// Parses & validates the bulk waste-account setup CSV. Returns one result per data row
// (valid or not) so the UI can preview everything — including errors — before anything
// is committed. Never invents a value for a field the row left blank.
export function parseAccountsCsv(text){
  const lines=text.split(/\r\n|\n|\r/).filter(l=>l.trim().length>0);
  if(lines.length===0) return {rows:[],headerError:"The file is empty."};
  const header=parseCSVLine(lines[0]).map(h=>h.trim().toLowerCase());
  const headerOk=header.length===ACCOUNT_CSV_HEADERS.length&&ACCOUNT_CSV_HEADERS.every((h,i)=>h===header[i]);
  if(!headerOk) return {rows:[],headerError:`Header row must be exactly: ${ACCOUNT_CSV_HEADERS.join(",")}`};
  if(lines.length===1) return {rows:[],headerError:"No data rows found below the header."};

  const rows=[];
  for(let i=1;i<lines.length;i++){
    const rowNum=i+1;
    const cols=parseCSVLine(lines[i]);
    if(cols.length!==ACCOUNT_CSV_HEADERS.length){
      rows.push({rowNum,account:null,error:`Row ${rowNum}: expected ${ACCOUNT_CSV_HEADERS.length} columns, found ${cols.length}.`});
      continue;
    }
    const [locationName,stream,containerType,containerQuantityStr,containerSizeStr,sizeUnitRaw,
      weeklyFreqStr,haulerName,accountNumber,hasVolumeStr,,hasWeightStr,weightUnitRaw,notes]=cols;

    let error=null;
    if(!locationName) error=`Row ${rowNum}: "location_name" is required.`;
    else if(!stream) error=`Row ${rowNum}: "stream" is required.`;
    else if(!WASTE_STREAMS.includes(stream)) error=`Row ${rowNum}: "stream" value "${stream}" must be one of ${WASTE_STREAMS.join(", ")}.`;

    let hasVolume=false,hasWeight=false,containerQuantity=null,containerSize=null,weeklyPickupFrequency=null;
    if(!error){const r=parseYesNo(hasVolumeStr,"has_volume",rowNum); if(r.error)error=r.error; else hasVolume=r.value;}
    if(!error){const r=parseYesNo(hasWeightStr,"has_weight",rowNum); if(r.error)error=r.error; else hasWeight=r.value;}
    if(!error){const r=parseOptionalNumber(containerQuantityStr,"container_quantity",rowNum); if(r.error)error=r.error; else containerQuantity=r.value;}
    if(!error){const r=parseOptionalNumber(containerSizeStr,"container_size",rowNum); if(r.error)error=r.error; else containerSize=r.value;}
    if(!error){const r=parseOptionalNumber(weeklyFreqStr,"weekly_pickup_frequency",rowNum); if(r.error)error=r.error; else weeklyPickupFrequency=r.value;}

    if(error){ rows.push({rowNum,account:null,error}); continue; }

    const weightUnit=/^lbs$/i.test((weightUnitRaw||"").trim())?"lbs":"tons";
    const sizeUnitNorm=(sizeUnitRaw||"").trim().toLowerCase();
    const sizeUnit=["yard","gal","other"].includes(sizeUnitNorm)?sizeUnitNorm:(sizeUnitNorm?"other":null);

    rows.push({
      rowNum,
      error:null,
      account:{
        name:`${locationName.trim()} ${stream}`.trim(),
        haulerName:(haulerName||"").trim(),
        stream,
        accountNumber:(accountNumber||"").trim(),
        notes:(notes||"").trim(),
        containerType:(containerType||"").trim(),
        containerQuantity,containerSize,sizeUnit,
        weeklyPickupFrequency,
        invoiceFormat:{hasVolume,hasWeight,weightUnit},
      },
    });
  }
  return {rows,headerError:null};
}
